/*
 * @Descripttion: 默认路由
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-14 15:41:49
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-29 14:19:03
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main'
import i18n from '@/utils/i18n'
Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/404',
    name: 'noPage',
    component: () => import('@/views/404'),
    hidden: true,
    meta: {}
  }
]

export const asyncRoutes = [
  {
    path: '/',
    component: Main,
    meta: {
      sort: 1
    },
    children: [
      {
        path: '',
        name: i18n.t('headMenus.index.name'),
        component: resolve => require(['../views/index/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: false,
          grade: 1, // 目录等级
          gradePath: 'index',
          title: 'headMenus.index.title',
          checked: '/'
        }
      }
    ]
  }, {
    path: '/about',
    component: Main,
    meta: {
      sort: 4
    },
    children: [
      {
        outName: 'headMenus.about.outName',
        path: '',
        name: i18n.t('headMenus.about.name'),
        title: 'headMenus.about.outTitle',
        component: resolve => require(['../views/about/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: false, // 界面是否显示header
          hearderNum: 0,
          grade: 1, // 目录等级
          gradePath: 'about',
          title: 'headMenus.about.title',
          checked: '/about'
        }
      }
    ]
  }, {
    path: '/cooperate',
    component: Main,
    meta: {
      sort: 5
    },
    children: [
      {
        path: '',
        name: i18n.t('headMenus.scienceResearch.outName'),
        component: resolve => require(['../views/cooperate/index.vue'], resolve),
        redirect: '/cooperate/scienceResearch',
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 0,
          header: false, // 是否在头部显示 --- 移动端 true为不显示
          grade: 1, // 目录等级
          gradePath: 'cooperate',
          title: 'headMenus.scienceResearch.outTitle',
          checked: '/cooperate/scienceResearch'
        },
        children: [
          {
            name: i18n.t('headMenus.scienceResearch.name'),
            path: 'scienceResearch',
            component: resolve => require(['../views/cooperate/scienceResearch/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              // grade: 2, // 目录等级
              gradePath: 'cooperate',
              header: true, // 是否在头部显示 --- 移动端 true为不显示
              title: 'headMenus.scienceResearch.title',
              checked: '/cooperate/scienceResearch'
            }
          }, {
            name: i18n.t('headMenus.license.name'),
            path: 'license',
            component: resolve => require(['../views/cooperate/license/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              // grade: 2, // 目录等级
              gradePath: 'cooperate',
              header: false, // 是否在头部显示 --- 移动端 true为不显示
              title: 'headMenus.license.title',
              checked: '/cooperate/license'
            }
          }
        ]
      }
    ]
  // }, {
  //   path: '/scienceResearch',
  //   component: Main,
  //   meta: {
  //     sort: 5
  //   },
  //   children: [
  //     {
  //       outName: i18n.t('headMenus.scienceResearch.outName'),
  //       name: i18n.t('headMenus.scienceResearch.name'),
  //       title: 'headMenus.scienceResearch.outTitle',
  //       path: '',
  //       component: resolve => require(['../views/cooperate/scienceResearch/index.vue'], resolve),
  //       meta: {
  //         show: true, // 是否可以点击跳转
  //         showHearder: true, // 界面是否显示header
  //         showFooter: true, // 界面是否显示footer
  //         hearderNum: 0,
  //         grade: 1, // 目录等级
  //         gradePath: 'cooperate',
  //         title: 'headMenus.scienceResearch.title',
  //         checked: '/scienceResearch'
  //       }
  //     }
  //   ]
  // },
  },
  {
    path: '/news',
    component: Main,
    meta: {
      sort: 7
    },
    children: [
      {
        name: i18n.t('headMenus.news.name'),
        path: '',
        component: resolve => require(['../views/news/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 0,
          grade: 2, // 目录等级
          gradePath: 'about',
          title: 'headMenus.news.title',
          checked: '/news'
        }
      }
    ]
  }, {
    path: '/innovative',
    component: Main,
    meta: {
      sort: 3
    },
    children: [
      {
        path: '',
        name: i18n.t('headMenus.innovative.name'),
        component: resolve => require(['../views/chuangxinChanpin/index.vue'], resolve),
        redirect: '/innovative/intracranial',
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 0,
          grade: 1, // 目录等级
          gradePath: 'innovative',
          title: 'headMenus.innovative.title',
          checked: '/innovative/intracranial'
        },
        children: [
          {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.intracranial'),
            path: 'intracranial',
            component: resolve => require(['../views/chuangxinChanpin/skull/intracranial/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'intracranial',
              type: {
                classify: 'skull',
                classHead: true
              },
              title: 'headMenus.innovative.intracranial',
              checked: '/innovative/intracranial'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AneuFlow'),
            path: 'intracranial/aneuflow',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuFlow/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuflow',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuFlow',
              checked: '/innovative/intracranial/aneuflow'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AneuGuide'),
            path: 'intracranial/aneuguide',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuGuide/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuguide',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AneuGuide',
              checked: '/innovative/intracranial/aneuguide'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AneuShape'),
            path: 'intracranial/aneushape',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuShape/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneushape',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuShape',
              checked: '/innovative/intracranial/aneushape'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AneuPlan'),
            path: 'intracranial/aneuplan',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuPlan/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuplan',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuPlan',
              checked: '/innovative/intracranial/aneuplan'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuASPECTS'),
            path: 'intracranial/accuaspects',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuASPECTS/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuaspects',
              type: {
                classify: 'skull',
                name: 'stroke',
                title: 'headMenus.innovative.stroke'
              },
              title: 'headMenus.innovative.AccuASPECTS',
              checked: '/innovative/intracranial/accuaspects'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuCTP'),
            path: 'intracranial/accuctp',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuCTP/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuctp',
              type: {
                classify: 'skull',
                name: 'stroke',
                title: 'headMenus.innovative.stroke'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuCTP',
              checked: '/innovative/intracranial/accuctp'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuFFicas'),
            path: 'intracranial/accufficas',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuFFicas/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accufficas',
              type: {
                classify: 'skull',
                name: 'narrow',
                title: 'headMenus.innovative.narrow'
              },
              title: 'headMenus.innovative.AccuFFicas',
              checked: '/innovative/intracranial/accufficas'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.intracardiac'),
            path: 'intracardiac',
            component: resolve => require(['../views/chuangxinChanpin/heart/intracardiac/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'intracardiac',
              type: {
                classify: 'heart',
                classHead: true
              },
              title: 'headMenus.innovative.intracardiac',
              checked: '/innovative/intracardiac'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuFFRct'),
            path: 'intracardiac/accuffrct',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRct/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrct',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              title: 'headMenus.innovative.AccuFFRct',
              checked: '/innovative/intracardiac/accuffrct'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuFFRangio'),
            path: 'intracardiac/accuffrangio',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRangio/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrangio',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              title: 'headMenus.innovative.AccuFFRangio',
              checked: '/innovative/intracardiac/accuffrangio'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuFFRivus'),
            path: 'intracardiac/accuffrivus',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRivus/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrivus',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuFFRivus',
              checked: '/innovative/intracardiac/accuffrivus'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuFFRoct'),
            path: 'intracardiac/accuffroct',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRoct/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffroct',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuFFRoct',
              checked: '/innovative/intracardiac/accuffroct'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuLV'),
            path: 'intracardiac/acculv',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuLV/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'acculv',
              type: {
                classify: 'heart',
                name: 'structureFunction',
                title: 'headMenus.innovative.structureFunction'
              },
              title: 'headMenus.innovative.AccuLV',
              checked: '/innovative/intracardiac/acculv'
            }
          }, {
            name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuIMR'),
            path: 'intracardiac/accuimr',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuIMR/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuimr',
              type: {
                classify: 'heart',
                name: 'structureFunction',
                title: 'headMenus.innovative.structureFunction'
              },
              title: 'headMenus.innovative.AccuIMR',
              checked: '/innovative/intracardiac/accuimr'
            }
          // }, {
            // name: i18n.t('headMenus.innovative.name') + '-' + i18n.t('headMenus.innovative.AccuVALVE'),
            // path: 'intracardiac/accuvalve',
            // component: resolve => require(['../views/chuangxinChanpin/heart/AccuVALVE/index.vue'], resolve),
            // meta: {
            //   show: true, // 是否可以点击跳转
            //   showHearder: true, // 界面是否显示header
            //   showFooter: true, // 界面是否显示footer
            //   hearderNum: 0,
            //   name: 'accuvalve',
            //   type: {
            //     classify: 'heart',
            //     name: 'structureFunction',
            //     title: 'headMenus.innovative.structureFunction'
            //   },
            //   title: 'headMenus.innovative.AccuVALVE',
            //   checked: '/innovative/intracardiac/accuvalve'
            // }
          }
        ]
      }
    ]
  }, {
    path: '/job',
    component: Main,
    meta: {
      sort: 8
    },
    children: [
      {
        name: i18n.t('headMenus.job.name'),
        path: '',
        component: resolve => require(['../views/job/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 0,
          grade: 1, // 目录等级
          gradePath: 'job',
          title: 'headMenus.job.title',
          checked: '/job'
        }
      }
    ]
  },
  /** 文档  start **************************/
  {
    path: '/privacy_policy',
    component: Main,
    meta: {
      sort: 10
    },
    children: [
      {
        name: i18n.t('headMenus.privacyPolicy.name'),
        path: '',
        component: resolve => require(['../views/word/privacyPolicy/index.vue'], resolve),
        meta: {
          show: false, // 是否可以点击跳转
          showHearder: false, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 1,
          header: true, // 是否在头部显示
          grade: 1, // 目录等级
          gradePath: 'privacyPolicy',
          title: 'headMenus.privacyPolicy.title',
          checked: '/privacy_policy'
        }
      }
    ]
  },
  {
    path: '/use_clause',
    component: Main,
    meta: {
      sort: 11
    },
    children: [
      {
        name: i18n.t('headMenus.useClause.name'),
        path: '',
        component: resolve => require(['../views/word/useClause/index.vue'], resolve),
        meta: {
          show: false, // 是否可以点击跳转
          showHearder: false, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 1,
          header: true, // 是否在头部显示
          grade: 1, // 目录等级
          gradePath: 'useClause',
          title: 'headMenus.useClause.title',
          checked: '/use_clause'
        }
      }
    ]
  },
  {
    path: '/guidance',
    component: Main,
    meta: {
      sort: 12
    },
    children: [
      {
        name: i18n.t('headMenus.guidance.name'),
        path: '',
        component: resolve => require(['../views/word/guidance/index.vue'], resolve),
        meta: {
          show: false, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: false, // 界面是否显示footer
          hearderNum: 1,
          header: true,
          grade: 1, // 目录等级
          gradePath: 'guidance',
          title: 'headMenus.guidance.title',
          checked: '/guidance'
        }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]
export const asyncRoutesEN = [
  {
    path: '/',
    component: Main,
    meta: {
      sort: 1
    },
    redirect: '/en',
    children: [
      {
        path: 'en',
        name: i18n.t('headMenus.index.name'),
        component: resolve => require(['../views/index/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: false,
          grade: 1, // 目录等级
          gradePath: 'index',
          title: 'headMenus.index.title',
          checked: '/en'
        }
      }
    ]
  }, {
    path: '/en/about',
    component: Main,
    name: i18n.t('headMenus.about.name'),
    meta: {
      sort: 4
    },
    children: [
      {
        outName: i18n.t('headMenus.about.outName'),
        path: '',
        name: i18n.t('headMenus.about.name'),
        title: 'headMenus.about.outTitle',
        component: resolve => require(['../views/about/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: false, // 界面是否显示header
          hearderNum: 0,
          grade: 1, // 目录等级
          gradePath: 'about',
          title: 'headMenus.about.title',
          checked: '/en/about'
        }
      }
    ]
  // }, {
  //   path: '/en/scienceResearch',
  //   component: Main,
  //   meta: {
  //     sort: 5
  //   },
  //   children: [
  //     {
  //       name: i18n.t('headMenus.scienceResearch.name'),
  //       path: '',
  //       component: resolve => require(['../views/scienceResearch/index.vue'], resolve),
  //       meta: {
  //         show: true, // 是否可以点击跳转
  //         showHearder: true, // 界面是否显示header
  //         showFooter: true, // 界面是否显示footer
  //         hearderNum: 0,
  //         grade: 1, // 目录等级
  //         gradePath: 'scienceResearch',
  //         title: 'headMenus.scienceResearch.title',
  //         checked: '/en/scienceResearch'
  //       }
  //     }
  //   ]
  }, {
    path: '/en/cooperate',
    component: Main,
    meta: {
      sort: 5
    },
    children: [
      {
        name: i18n.t('headMenus.license.name'),
        path: '',
        component: resolve => require(['../views/cooperate/license/index.vue'], resolve),
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 1,
          grade: 1, // 目录等级
          header: false, // 是否在头部显示
          gradePath: 'cooperate',
          title: 'headMenus.license.title',
          checked: '/en/cooperate'
        }
      }
    ]
  }, {
    path: '/en/innovative',
    component: Main,
    meta: {
      sort: 3
    },
    children: [
      {
        path: '',
        name: i18n.t('headMenus.innovative.name'),
        component: resolve => require(['../views/chuangxinChanpin/index.vue'], resolve),
        redirect: '/en/innovative/intracranial',
        meta: {
          show: true, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: true, // 界面是否显示footer
          hearderNum: 0,
          grade: 1, // 目录等级
          gradePath: 'innovative',
          title: 'headMenus.innovative.title',
          checked: '/en/innovative/intracranial'
        },
        children: [
          {
            name: i18n.t('headMenus.innovative.intracranial'),
            path: 'intracranial',
            component: resolve => require(['../views/chuangxinChanpin/skull/intracranial/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'intracranial',
              type: {
                classify: 'skull',
                classHead: true
              },
              title: 'headMenus.innovative.intracranial',
              checked: '/en/innovative/intracranial'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AneuFlow',
            path: 'intracranial/aneuflow',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuFlow/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuflow',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuFlow',
              checked: '/en/innovative/intracranial/aneuflow'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AneuGuide',
            path: 'intracranial/aneuguide',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuGuide/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuguide',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AneuGuide',
              checked: '/en/innovative/intracranial/aneuguide'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AneuShape',
            path: 'intracranial/aneushape',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuShape/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneushape',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuShape',
              checked: '/en/innovative/intracranial/aneushape'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AneuPlan',
            path: 'intracranial/aneuplan',
            component: resolve => require(['../views/chuangxinChanpin/skull/AneuPlan/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'aneuplan',
              type: {
                classify: 'skull',
                name: 'aneurysm',
                title: 'headMenus.innovative.aneurysm'
              },
              title: 'headMenus.innovative.AneuPlan',
              checked: '/en/innovative/intracranial/aneuplan'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuASPECTS',
            path: 'intracranial/accuaspects',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuASPECTS/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuaspects',
              type: {
                classify: 'skull',
                name: 'stroke',
                title: 'headMenus.innovative.stroke'
              },
              title: 'headMenus.innovative.AccuASPECTS',
              checked: '/en/innovative/intracranial/accuaspects'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuCTP',
            path: 'intracranial/accuctp',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuCTP/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuctp',
              type: {
                classify: 'skull',
                name: 'stroke',
                title: 'headMenus.innovative.stroke'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuCTP',
              checked: '/en/innovative/intracranial/accuctp'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuICAS',
            path: 'intracranial/accuicas',
            component: resolve => require(['../views/chuangxinChanpin/skull/AccuFFicas/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuicas',
              type: {
                classify: 'skull',
                name: 'narrow',
                title: 'headMenus.innovative.narrow'
              },
              title: 'headMenus.innovative.AccuFFicas',
              checked: '/en/innovative/intracranial/accuicas'
            }
          }, {
            name: i18n.t('headMenus.innovative.intracardiac'),
            path: 'intracardiac',
            component: resolve => require(['../views/chuangxinChanpin/heart/intracardiac/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'intracardiac',
              type: {
                classify: 'heart',
                classHead: true
              },
              title: 'headMenus.innovative.intracardiac',
              checked: '/en/innovative/intracardiac'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuFFRct',
            path: 'intracardiac/accuffrct',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRct/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrct',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              title: 'headMenus.innovative.AccuFFRct',
              checked: '/en/innovative/intracardiac/accuffrct'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuFFRangio',
            path: 'intracardiac/accuffrangio',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRangio/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrangio',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuFFRangio',
              checked: '/en/innovative/intracardiac/accuffrangio'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuFFRivus',
            path: 'intracardiac/accuffrivus',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRivus/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffrivus',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              hot: false, // 有HOT图标
              title: 'headMenus.innovative.AccuFFRivus',
              checked: '/en/innovative/intracardiac/accuffrivus'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuFFRoct',
            path: 'intracardiac/accuffroct',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuFFRoct/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuffroct',
              type: {
                classify: 'heart',
                name: 'accuffr',
                title: 'headMenus.innovative.accuffr'
              },
              title: 'headMenus.innovative.AccuFFRoct',
              checked: '/en/innovative/intracardiac/accuffroct'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuLV',
            path: 'intracardiac/acculv',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuLV/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'acculv',
              type: {
                classify: 'heart',
                name: 'structureFunction',
                title: 'headMenus.innovative.structureFunction'
              },
              title: 'headMenus.innovative.AccuLV',
              checked: '/en/innovative/intracardiac/acculv'
            }
          }, {
            name: i18n.t('headMenus.index.name') + '-AccuIMR',
            path: 'intracardiac/accuimr',
            component: resolve => require(['../views/chuangxinChanpin/heart/AccuIMR/index.vue'], resolve),
            meta: {
              show: true, // 是否可以点击跳转
              showHearder: true, // 界面是否显示header
              showFooter: true, // 界面是否显示footer
              hearderNum: 0,
              name: 'accuimr',
              type: {
                classify: 'heart',
                name: 'structureFunction',
                title: 'headMenus.innovative.structureFunction'
              },
              title: 'headMenus.innovative.AccuIMR',
              checked: '/en/innovative/intracardiac/accuimr'
            }
          // }, {
            // name: i18n.t('headMenus.index.name') + '-AccuVALVE',
            // path: 'intracardiac/accuvalve',
            // component: resolve => require(['../views/chuangxinChanpin/heart/AccuVALVE/index.vue'], resolve),
            // meta: {
            //   show: true, // 是否可以点击跳转
            //   showHearder: true, // 界面是否显示header
            //   showFooter: true, // 界面是否显示footer
            //   hearderNum: 0,
            //   name: 'accuvalve',
            //   type: {
            //     classify: 'heart',
            //     name: 'structureFunction',
            //     title: 'headMenus.innovative.structureFunction'
            //   },
            //   title: 'headMenus.innovative.AccuVALVE',
            //   checked: '/en/innovative/intracardiac/accuvalve'
            // }
          }
        ]
      }
    ]
  }, {
    path: '/en/guidance',
    component: Main,
    meta: {
      sort: 11
    },
    children: [
      {
        name: i18n.t('headMenus.guidance.name'),
        path: '',
        component: resolve => require(['../views/word/guidance/index.vue'], resolve),
        meta: {
          show: false, // 是否可以点击跳转
          showHearder: true, // 界面是否显示header
          showFooter: false, // 界面是否显示footer
          hearderNum: 1,
          header: true, // 是否在头部显示
          grade: 1, // 目录等级
          gradePath: 'guidance',
          title: 'headMenus.guidance.title',
          checked: '/en/guidance'
        }
      }
    ]
  }, {
    path: '/en/angioPDF',
    component: resolve => require(['../views/word/angioPDF/index.vue'], resolve),
    meta: {
      sort: 12,
      show: false, // 是否可以点击跳转
      showHearder: true, // 界面是否显示header
      showFooter: false, // 界面是否显示footer
      hearderNum: 1,
      header: true, // 是否在头部显示
      grade: 1 // 目录等级
    }
  }, {
    path: '/en/angioPDF1',
    component: resolve => require(['../views/word/angioPDF/index1.vue'], resolve),
    meta: {
      sort: 12,
      show: false, // 是否可以点击跳转
      showHearder: true, // 界面是否显示header
      showFooter: false, // 界面是否显示footer
      hearderNum: 1,
      header: true, // 是否在头部显示
      grade: 1 // 目录等级
    }
  }, {
    path: '/en/imrPDF',
    component: resolve => require(['../views/word/imrPDF/index.vue'], resolve),
    meta: {
      sort: 13,
      show: false, // 是否可以点击跳转
      showHearder: true, // 界面是否显示header
      showFooter: false, // 界面是否显示footer
      hearderNum: 1,
      header: true, // 是否在头部显示
      grade: 1 // 目录等级
    }
  },
  { path: '*', redirect: '/404', hidden: true }
]
const createRouter = () => new VueRouter({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
export function resetRouter () {
  const newRouter = createRouter()
  router.match = newRouter.match // reset router
}

export default router
